import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { change } from 'redux-form'
import { impressionPlanCreate, impressionPlansLoad, impressionPlanUpdate } from '../../../../redux/actions/settingActions/impressionPlanActions'

export default function ImpressionPlanComp(props) {
  const { member, pprops, impression } = props
  const dispatch = useDispatch()
  const [showDropdown, setShowDropdown] = useState(false) // show by default
  const [associatedPlans, setAssociatedPlans] = useState(impression.associated_plans_attributes ?? [])
  const [associatedPlanEdit, setAssociatedPlanEdit] = useState(null)
  const [impressionAssociatedPlans, setImpressionAssociatedPlans] = useState([]) // show on search
  const [search, setSearch] = useState('')
  const [latestAddedPlan, setLatestAddedPlan] = useState('')
  const searchField = useRef(null)

  useEffect(() => {
    setAssociatedPlans(impression.associated_plans_attributes)
  }, [impression.associated_plans_attributes])

  const handleAddImpressionPlan = (data) => {
    let selectedAssociatedPlanIds = impression?.associated_plans_attributes ?? []
    selectedAssociatedPlanIds = selectedAssociatedPlanIds.filter(item => item.id)
    dispatch(change('procedureImpressionPlanForm', `${member}.associated_plans_attributes`, [...selectedAssociatedPlanIds, data]))
    setTimeout(() => pprops.submit(), 500)
    setSearch('')
    setShowDropdown(false)
  }

  const handleRemoveAssociatedPlan = (id) => {
    let selectedAssociatedPlanIds = impression?.associated_plans_attributes.map(item => item.id === id ? { ...item, _destroy: true } : item)
    selectedAssociatedPlanIds = selectedAssociatedPlanIds.filter(item => item.id)
    dispatch(change('procedureImpressionPlanForm', `${member}.associated_plans_attributes`, selectedAssociatedPlanIds))
    setTimeout(() => pprops.submit(), 500)
  }

  const handleClickOutside = (event) => {
    const allowAssociatePlans = document.getElementById('associate_plans')
    const reset = allowAssociatePlans && !allowAssociatePlans.contains(event.target)
    if (reset) {
      setShowDropdown(false)
    }
  }

  useEffect(() => {
    if (showDropdown) {
      document.removeEventListener('mousedown', handleClickOutside)
      setLatestAddedPlan('')
    }
    else {
      document.addEventListener('mousedown', handleClickOutside)
    }
  }, [showDropdown])

  const getImpressionPlans = async (val) => {
    // search associated plans corresponding to impression
    let associated_plans = await dispatch(impressionPlansLoad({ search: val, filter: { settings_impression_id: impression.settings_impression_id }, rpp: 99 }))
    associated_plans = associated_plans.action.payload.data.associated_plans
    setImpressionAssociatedPlans(associated_plans)
  }

  const handlePlanEdit = () => {
    // edit an associated plan for exam
    setShowDropdown(false)
    const newUpdatedArr = associatedPlans.map(item => item.id === associatedPlanEdit.id ? associatedPlanEdit : item)
    dispatch(change('procedureImpressionPlanForm', `${member}.associated_plans_attributes`, newUpdatedArr))
    setTimeout(() => pprops.submit(), 500)
    setAssociatedPlanEdit(null)
  }

  const handleOnChange = async (val) => {
    setSearch(val)
    getImpressionPlans(val)
    setShowDropdown(true)
  }

  const addImpressionPlan = async () => {
    let res = await dispatch(impressionPlanCreate({ name: search.trim(), settings_impression_id: impression.settings_impression_id, is_default: false }))
    res = res.value.data
    handleAddImpressionPlan({ settings_associated_plan_id: res.associated_plan.id })
    searchField.current.blur();
    setShowDropdown(true)
    getImpressionPlans(res.associated_plan.name)
    setLatestAddedPlan(res.associated_plan.name)
  }

  const handleSetDefaultPlan = async (data) => {
    let res = await dispatch(impressionPlanUpdate({ ...data, settings_impression_id: impression.settings_impression_id }))
    res = res.value.data.associated_plan
    if (latestAddedPlan === data.name && impressionAssociatedPlans.length === 1) {
      getImpressionPlans(data.name)
    }
    else {
      getImpressionPlans(search)
    }
  }

  return (
    <>
      <div className='position-relative'>
        {associatedPlanEdit?.id ?
          <div>
            <div className='d-flex justify-content-between'>
              <label>Edit Plan Name</label>
              <span className='text-danger pointer' onClick={() => setAssociatedPlanEdit(null)}>
                <i className="las la-times-circle font-size-20"></i>
              </span>
            </div>
            <div className='d-flex'>
              <input
                type="text"
                className='form-control font-control-sm'
                value={associatedPlanEdit.name}
                onChange={(e) => setAssociatedPlanEdit({ ...associatedPlanEdit, name: e.target.value })}
              />
              <button type='button' className='btn btn-primary btn-sm rounded-0 px-4 py-0' onClick={() => handlePlanEdit()}>Save</button>
            </div>
          </div> :
          <div className='d-flex align-items-center'>
            <div className="input-group mb-5">
              <input ref={searchField} value={search} onChange={(e) => handleOnChange(e.target.value)} type="text" className="form-control" placeholder={`Type to search`} onFocus={(e) => handleOnChange(e.target.value)} />
              {impressionAssociatedPlans?.length == 0 && search != "" ?
                <div className="input-group-append" onClick={() => addImpressionPlan()}>
                  <span className="input-group-text pointer position-static bg-primary text-white">Add</span>
                </div> :
                <div className="input-group-append">
                  <span className="input-group-text search-button position-static bg-light"><i className="la la-search text-muted" /></span>
                </div>
              }
            </div>
          </div>
        }
        {impressionAssociatedPlans.length ? <div className={`position-absolute w-100 z-index-2 overflow-auto max-height-19 shadow ${showDropdown ? 'd-block' : 'd-none'}`} id={showDropdown ? 'associate_plans' : false}>
          <table className="table table-hover bg-white mb-0">
            <thead className="text-dark border-bottom border-light border-bottom-2">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Plan Name</th>
                <th scope="col">Set as default</th>
              </tr>
            </thead>
            <tbody>
              {impressionAssociatedPlans?.map((item, index) => <tr key={item.id}>
                <td>{index + 1}</td>
                <td className='pointer' onClick={() => handleAddImpressionPlan({ settings_associated_plan_id: item.id })}>{item.name}</td>
                <td className='pl-7'>
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" onChange={(e) => handleSetDefaultPlan({ id: item.id, name: item.name, is_default: e.target.checked })} checked={item.is_default} className="custom-control-input" id={`impression-plan-${item.id}`} />
                    <label className="custom-control-label" htmlFor={`impression-plan-${item.id}`}></label>
                  </div>
                </td>
              </tr>)}
            </tbody>
          </table>
        </div> : ''}
        <div className='mt-3'>
          {associatedPlans?.map((item) => associatedPlanEdit?.id !== item.id && <span className={`btn btn-outline-primary px-3 mr-3 mb-3`}>
            <span onDoubleClick={() => setAssociatedPlanEdit(item)}>
              {item.name}
            </span>
            <span className='pl-3' onClick={() => handleRemoveAssociatedPlan(item.id)}>
              <i className="las la-times"></i>
            </span>
          </span>)}
        </div>
      </div>
    </>
  )
}